module.exports = __webpack_public_path__ + "static/img/11.ebd92e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/11.png
// module id = m81t
// module chunks = 0